import React, { useMemo } from "react";

import { Table } from "semantic-ui-react";

import { useDictionary } from "hooks";

import styles from "./styles.css";

const DEFAULT_HEADER_CELLS = [
	<Table.HeaderCell key={1} className={styles.tableHeaderItem}>On Campus</Table.HeaderCell>,
	<Table.HeaderCell key={2} className={styles.tableHeaderItem}>Off Campus</Table.HeaderCell>,
];

export const RateTypeHeader = ({ dateRanges, rateOrder }) => {
	const dictionary = useDictionary("budgetBuilder.components.RateTypeTable");
	const rates = dateRanges?.[0]?.rates;
	const headerCells = useMemo(() => {
		if (!(dateRanges && dateRanges.length > 0 && dateRanges[0]?.rates)) {
			return DEFAULT_HEADER_CELLS;
		}
		let headerCells = [];
		for (let i = 0; i < rates.length; i++) {
			const rate = rates[i];
			const providedOrder = rateOrder[rate?.categoryId];
			if (providedOrder === 0 || providedOrder) {
				headerCells[providedOrder] = (
					<Table.HeaderCell key={i} className={styles.tableHeaderItem}>
						{rate?.categoryName || "--"}
					</Table.HeaderCell>
				);
			}
		}

		return headerCells;
	}, [ dateRanges, rateOrder, rates ]);

	return (
		<Table.Row key="headerRow">
			<Table.HeaderCell className={styles.tableHeaderItem}>{dictionary?.type || "Type"}</Table.HeaderCell>
			{headerCells}
		</Table.Row>
	);
};
